export const cuartosFriosHeroImage =
  "https://readdy.ai/api/search-image?query=Modern%20industrial%20cold%20storage%20room%20interior%20with%20white%20insulated%20sandwich%20panels%20on%20walls%20and%20ceiling%2C%20bright%20professional%20LED%20lighting%20strips%2C%20stainless%20steel%20evaporator%20refrigeration%20unit%2C%20clean%20cold%20room%20environment%2C%20cool%20blue%20white%20and%20steel%20gray%20tones%2C%20high%20detail%20editorial%20industrial%20photography%2C%20harmonious%20composition&width=1600&height=800&seq=cuartos-frios-hero-1&orientation=landscape";

export const cuartosFriosIntroImage =
  "https://readdy.ai/api/search-image?query=Technical%20detail%20of%20a%20professional%20cold%20room%20refrigeration%20system%2C%20stainless%20steel%20evaporator%20unit%20with%20fan%20and%20white%20insulated%20panel%20wall%2C%20industrial%20cooling%20equipment%2C%20clean%20cold%20storage%20environment%2C%20cool%20steel%20gray%20and%20white%20tones%2C%20soft%20studio%20lighting%2C%20editorial%20industrial%20photography%2C%20high%20detail&width=900&height=600&seq=cuartos-frios-intro-1&orientation=landscape";

export const cuartosFriosConservacionImage =
  "https://readdy.ai/api/search-image?query=Spacious%20walk-in%20cold%20storage%20room%20for%20food%20conservation%20with%20white%20insulated%20panels%2C%20metal%20shelving%20filled%20with%20fresh%20produce%20boxes%2C%20bright%20clean%20professional%20lighting%2C%20stainless%20steel%20door%2C%20cool%20white%20and%20steel%20gray%20tones%2C%20professional%20industrial%20photography%2C%20high%20detail&width=800&height=600&seq=cuartos-frios-conservacion-1&orientation=landscape";

export const cuartosFriosCongelacionImage =
  "https://readdy.ai/api/search-image?query=Industrial%20freezer%20room%20with%20thick%20white%20insulated%20panels%2C%20heavy%20frost%20on%20evaporator%20coils%2C%20metal%20racks%20with%20frozen%20food%20cartons%2C%20bright%20cold%20blue%20white%20lighting%2C%20deep%20freeze%20environment%2C%20cool%20blue%20and%20white%20steel%20tones%2C%20professional%20industrial%20photography%2C%20high%20detail&width=800&height=600&seq=cuartos-frios-congelacion-1&orientation=landscape";

export const cuartosFriosTypes = [
  {
    title: "CUARTOS DE CONSERVACIÓN",
    description:
      "Soluciones diseñadas para mantener productos a temperaturas controladas y preservar sus condiciones de almacenamiento.",
    image: cuartosFriosConservacionImage,
    icon: "ri-snowy-line",
  },
  {
    title: "CUARTOS DE CONGELACIÓN",
    description:
      "Sistemas diseñados para procesos que requieren temperaturas más bajas y conservación mediante congelación.",
    image: cuartosFriosCongelacionImage,
    icon: "ri-thermometer-line",
  },
] as const;

export const cuartosFriosServices = [
  {
    title: "DISEÑO DE CUARTOS FRÍOS",
    description:
      "Diseño de soluciones según dimensiones, producto y temperatura requerida.",
    icon: "ri-pencil-ruler-2-line",
  },
  {
    title: "INSTALACIÓN",
    description:
      "Montaje profesional de equipos, sistemas de refrigeración y componentes.",
    icon: "ri-tools-line",
  },
  {
    title: "MANTENIMIENTO PREVENTIVO",
    description:
      "Revisión periódica para conservar el rendimiento y reducir el riesgo de fallas.",
    icon: "ri-timer-line",
  },
  {
    title: "MANTENIMIENTO CORRECTIVO",
    description:
      "Diagnóstico y reparación de fallas en equipos y sistemas de refrigeración.",
    icon: "ri-settings-3-line",
  },
  {
    title: "OPTIMIZACIÓN DE SISTEMAS",
    description:
      "Evaluación y mejora de sistemas existentes para lograr un funcionamiento más eficiente.",
    icon: "ri-line-chart-line",
  },
] as const;

export const cuartosFriosSectors = [
  {
    name: "Industria de alimentos",
    image:
      "https://readdy.ai/api/search-image?query=Food%20processing%20facility%20with%20stainless%20steel%20cold%20storage%20room%20and%20workers%20in%20clean%20uniforms%20handling%20packaged%20products%2C%20bright%20hygienic%20lighting%2C%20cool%20white%20and%20steel%20gray%20tones%2C%20professional%20industrial%20photography%2C%20high%20detail&width=400&height=300&seq=cuartos-frios-sector-1&orientation=landscape",
  },
  {
    name: "Restaurantes y hoteles",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20hotel%20kitchen%20cold%20storage%20room%20with%20white%20insulated%20panels%20and%20stainless%20steel%20shelving%20stocked%20with%20fresh%20ingredients%2C%20clean%20bright%20food%20service%20environment%2C%20cool%20white%20steel%20tones%2C%20professional%20hospitality%20photography%2C%20high%20detail&width=400&height=300&seq=cuartos-frios-sector-2&orientation=landscape",
  },
  {
    name: "Supermercados",
    image:
      "https://readdy.ai/api/search-image?query=Supermarket%20back%20of%20house%20walk-in%20cooler%20with%20white%20insulated%20walls%20and%20metal%20shelves%20of%20fresh%20produce%20and%20dairy%20products%2C%20bright%20clean%20commercial%20refrigeration%20environment%2C%20cool%20white%20steel%20tones%2C%20professional%20retail%20photography%2C%20high%20detail&width=400&height=300&seq=cuartos-frios-sector-3&orientation=landscape",
  },
  {
    name: "Carnicerías y pescaderías",
    image:
      "https://readdy.ai/api/search-image?query=Butcher%20shop%20cold%20room%20with%20white%20insulated%20panels%2C%20stainless%20steel%20hooks%20and%20fresh%20meat%20hanging%20in%20controlled%20refrigeration%2C%20bright%20clean%20hygienic%20environment%2C%20cool%20white%20steel%20tones%2C%20professional%20food%20industry%20photography%2C%20high%20detail&width=400&height=300&seq=cuartos-frios-sector-4&orientation=landscape",
  },
  {
    name: "Frutas y verduras",
    image:
      "https://readdy.ai/api/search-image?query=Walk-in%20cold%20storage%20room%20for%20fruits%20and%20vegetables%20with%20white%20insulated%20panels%20and%20wooden%20crates%20filled%20with%20fresh%20colorful%20produce%2C%20bright%20clean%20refrigeration%20lighting%2C%20cool%20white%20tones%2C%20professional%20agriculture%20photography%2C%20high%20detail&width=400&height=300&seq=cuartos-frios-sector-5&orientation=landscape",
  },
  {
    name: "Centros de distribución",
    image:
      "https://readdy.ai/api/search-image?query=Large%20distribution%20center%20cold%20storage%20warehouse%20with%20white%20insulated%20walls%2C%20tall%20metal%20racking%20filled%20with%20pallets%20of%20packaged%20goods%2C%20forklift%20in%20motion%2C%20bright%20industrial%20refrigeration%20lighting%2C%20cool%20white%20steel%20tones%2C%20professional%20logistics%20photography%2C%20high%20detail&width=400&height=300&seq=cuartos-frios-sector-6&orientation=landscape",
  },
  {
    name: "Empresas de almacenamiento",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20organized%20cold%20storage%20warehouse%20interior%20with%20white%20insulated%20panels%20and%20metal%20shelving%20stacked%20with%20boxes%2C%20bright%20cool%20lighting%2C%20empty%20aisle%20perspective%2C%20cool%20white%20steel%20tones%2C%20professional%20industrial%20photography%2C%20high%20detail&width=400&height=300&seq=cuartos-frios-sector-7&orientation=landscape",
  },
  {
    name: "Procesos industriales",
    image:
      "https://readdy.ai/api/search-image?query=Industrial%20refrigeration%20plant%20interior%20with%20large%20stainless%20steel%20cooling%20equipment%2C%20pipes%20and%20white%20insulated%20cold%20room%20panels%2C%20clean%20modern%20process%20facility%2C%20cool%20white%20steel%20blue%20tones%2C%20professional%20industrial%20engineering%20photography%2C%20high%20detail&width=400&height=300&seq=cuartos-frios-sector-8&orientation=landscape",
  },
] as const;

export const cuartosFriosBenefits = [
  {
    title: "TEMPERATURA CONTROLADA",
    description:
      "Condiciones de temperatura estables y precisas para cada tipo de producto.",
    icon: "ri-thermometer-line",
  },
  {
    title: "CONSERVACIÓN DEL PRODUCTO",
    description:
      "Preserva la calidad, frescura y vida útil de los productos almacenados.",
    icon: "ri-archive-line",
  },
  {
    title: "EFICIENCIA ENERGÉTICA",
    description:
      "Sistemas dimensionados correctamente para optimizar el consumo energético.",
    icon: "ri-lightbulb-line",
  },
  {
    title: "CONFIABILIDAD OPERATIVA",
    description:
      "Equipos correctamente instalados y mantenidos para un funcionamiento continuo.",
    icon: "ri-shield-check-line",
  },
] as const;

export const cuartosFriosProcess = [
  {
    step: "01",
    title: "DIAGNÓSTICO",
    description: "Evaluación del espacio, producto y necesidades de refrigeración.",
  },
  {
    step: "02",
    title: "DISEÑO",
    description: "Definición del sistema, temperatura y distribución del espacio.",
  },
  {
    step: "03",
    title: "INSTALACIÓN",
    description: "Montaje de paneles, equipos y sistemas de refrigeración.",
  },
  {
    step: "04",
    title: "PUESTA EN MARCHA",
    description: "Pruebas, calibración y verificación del funcionamiento.",
  },
  {
    step: "05",
    title: "MANTENIMIENTO",
    description: "Seguimiento y mantenimiento para asegurar el rendimiento.",
  },
] as const;